import { render, staticRenderFns } from "./DetalleEvaluacionRespetoPrincipios.vue?vue&type=template&id=51d5d9f0"
import script from "./DetalleEvaluacionRespetoPrincipios.vue?vue&type=script&lang=js"
export * from "./DetalleEvaluacionRespetoPrincipios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports